import { render, staticRenderFns } from "./ModalCamposAlternativosItemOportunidade.vue?vue&type=template&id=116cf275&scoped=true"
import script from "./ModalCamposAlternativosItemOportunidade.vue?vue&type=script&lang=js"
export * from "./ModalCamposAlternativosItemOportunidade.vue?vue&type=script&lang=js"
import style0 from "./ModalCamposAlternativosItemOportunidade.vue?vue&type=style&index=0&id=116cf275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116cf275",
  null
  
)

export default component.exports